import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { MODAL_SIZES, STRATEGY_SETS_RESULTS } from 'shared-modules/constants';
import { Button, Modal } from '../../../../../components';
import styles from '../../StrategiesSuccess/strategiesSuccess.module.scss';

export const PartialFailedModal = memo(({ isOpen, closeModal, title, info, strategyResults }) => {
  return (
    <Modal isOpen={isOpen} closeModal={closeModal} size={MODAL_SIZES.WIDTH_512} withoutHeader isErrorNotification>
      <div className={styles.errorIconContainer}>
        <i className={classNames('material-icons-outlined', styles.errorIcon)}>error_outline</i>
      </div>
      <div className={styles.errorMessageTitle}>{title}</div>
      <div className={styles.errorMessageInfo}>{info}</div>
      <div className={styles.scrollableInfoContainer}>
        {strategyResults?.map?.((strategyResult) => (
          <div className={styles.setsRow} key={strategyResult.strategyId}>
            <div className={styles.dot}>・</div>
            <div>
              <div className={classNames(styles.strategiesName, styles.text)}>
                {strategyResult.status === STRATEGY_SETS_RESULTS.FAIL && (
                  <span className={styles.errorMessage}>[失敗] </span>
                )}
                {strategyResult.status === STRATEGY_SETS_RESULTS.SUCCESS && (
                  <span className={styles.successMessage}>[成功] </span>
                )}
                {strategyResult.strategyName}
              </div>
              {strategyResult.status === STRATEGY_SETS_RESULTS.FAIL && (
                <div className={classNames(styles.resultMessage, styles.text, styles.errReasonText)}>
                  {strategyResult.errReason}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
      <div className={styles.buttonContainer}>
        <Button width={400} className={styles.closeErrorModalButton} secondary onClick={closeModal}>
          とじる
        </Button>
      </div>
    </Modal>
  );
});

PartialFailedModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  info: PropTypes.string.isRequired,
  strategyResults: PropTypes.arrayOf(PropTypes.shape({})), // TODO shape
};

PartialFailedModal.defaultProps = {
  strategyResults: [],
};
